<template>
  <div>
    <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5"> </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12 order-xl-1 bg-white p-8">
            <h1>Tem certeza?</h1>

            <p>Ao cancelar sua assinatura, o acesso a sua conta ficará ativa até a data final do ciclo.</p>

            <div class="pt-4 pb-4">
                <base-button
                    type="danger"
                    @click="cancelar()"
                    v-html="textoBotao"
                ></base-button>
            </div>

              <template v-if="loading">
                    <div class="m-2">
                    <skeleton altura="60px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                    </div>
                </template>

            <p><strong v-html="textoMsg"></strong></p>
</div>
      </div>
    </div>
  </div>
</template>
<script>

import usuario from '@/cflow/usuario.js';
import storage from "@/cflow/storageService";

var cancelarAssinatura = {
  components: {

  },
  computed: {
  },
  methods: {
    cancelar() {

        var _this = this;
        _this.loading = true;
        var user = storage.get("user");
        usuario.cancelar(user).then(() => {
            _this.textoMsg = 'Sucesso ao suspender sua assinatura!';
            _this.loading = false;
        }).catch(() => {
            _this.textoMsg = 'Houve um erro ao suspender sua assinatura, já cancelada talvez?';
            _this.loading = false;
        });

    }
  },
  mounted: function () {
   
  },
  data() {
    return {
      textoBotao: 'Cancelar assinatura',
      loading: false
    };
  },
};
export default cancelarAssinatura;
</script>
<style lang="scss" scoped>

</style>
